import secureLocalStorage from "react-secure-storage";
class SecureStorage{
static setItem=(key,value)=>{
    
    secureLocalStorage.setItem(key,value)
}
static getItem=(key)=>{
  return secureLocalStorage.getItem(key)!== null &&  secureLocalStorage.getItem(key)!== undefined ? null :secureLocalStorage.getItem(key)
}
static removeitem=(key)=>{
    secureLocalStorage.removeItem(key)
}
static clear=( )=>{
    secureLocalStorage.clear()
}
}

export default SecureStorage;
 